export default () => {
	const items = document.querySelectorAll('.quickbuy');
	items.forEach(function(qb) {
		const button = qb.querySelector('.quickbuy__submit');
		const swatches = qb.querySelectorAll('.js-qb-swatch');

		if (button) {
			button.addEventListener('click', (e) => {
				expand(qb);

				if (button.classList.contains('js-buy-btn')) {
					setTimeout(function(){
						reset(button.closest('.js-card'))
						button.classList.remove('js-buy-btn');
						qb.classList.remove('quickbuy--selected');
						qb.classList.remove('quickbuy--expanded');
					}, 600);
				}
			});
		}

		swatches.forEach(function(swatch) {
			swatch.addEventListener('click', (e) => {
				e.preventDefault();
				if (!swatch.classList.contains('quickbuy__button--active')) {
					swatches.forEach(function(s) {
						s.classList.remove('quickbuy__button--active')
					});
					swatch.classList.add('quickbuy__button--active');
					button.dataset.id = swatch.dataset.id;
					button.classList.add('js-buy-btn');
					qb.classList.add('quickbuy--selected');
				}
			});
		});
	});

	function expand(el) {
		el.classList.add('quickbuy--expanded');
		let card = el.closest('.js-card');
		if (card) {
			card.classList.add('is-expanded');
		}
	}
	function close(el) {
		el.classList.remove('quickbuy--expanded');
		let card = el.closest('.js-card');
		if (card) {
			card.classList.remove('is-expanded');
		}
	}
	function reset(card) {
		card.classList.remove('is-expanded');
	}
}